export const productsData = [
    {
        title: "Model Y",
        subTitle: "From $29,490*",
        description: "After Federal Tax Credit & Est. Gas Savings",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-Y-Desktop-Global.png",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-Y-Mobile-Global.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/modely/design#overview"
            },
            {
                text: "Demo Drive",
                link: "https://www.tesla.com/drive?selectedModel=modely"
            }
        ],
        disclaimer: "*Price before incentives is $42,990, excluding taxes and fees. Subject to change.",
        disclaimerLink: {
            text: "Learn about est. gas savings.",
            link: "https://www.tesla.com/modely/design?financeModalTab=gas_savings#overview"
        }
    },
    {
        title: "Model 3",
        subTitle: "From $299/mo*",
        description: "Est. Lease Price Before Gas Savings",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-3-Desktop-LHD-v2.jpg",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-3-Mobile-LHD-v2.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/model3/design#overview"
            },
            {
                text: "Demo Drive",
                link: "https://www.tesla.com/drive?selectedModel=Model3"
            }
        ],
        disclaimer: "*Excludes taxes and fees with price subject to change. Available in select states.",
        disclaimerLink: {
            text: "See Details",
            link: "https://www.tesla.com/model3/design?financeModalTab=finance_options#overview"
        },
        disclaimerColor: "white"
    },
    {
        title: "Model X",
        subTitle: "From $63,990*",
        description: "After Federal Tax Credit & Est. Gas Savings",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-X-Desktop.jpg",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/h_1700,q_auto:best/Homepage-Model-X-Mobile-LHD_001',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/modelx/design#overview"
            },
            {
                text: "Demo Drive",
                link: "https://www.tesla.com/drive?selectedModel=modelx"
            }
        ],
        disclaimer: "*Price before incentives and savings is $77,990, excluding taxes and fees. Subject to change.",
        disclaimerLink: {
            text: "Learn about est. gas savings",
            link: "https://www.tesla.com/modelx/design?financeModalTab=gas_savings#overview"
        },
        disclaimerColor: "white"
    },
    {
        title: "Model S",
        subTitle: "From $66,490*",
        description: "After Est. Gas Savings",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-S-Desktop-LHD-6.22.jpg",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Model-S-Mobile-LHD-6.22.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/models/design#overview"
            },
            {
                text: "Demo Drive",
                link: "https://www.tesla.com/drive?selectedModel=models"
            }
        ],
        disclaimer: "*Price before savings is $72,990, excluding taxes and fees. Subject to change.",
        disclaimerLink: {
            text: "Learn about est. gas savings",
            link: "https://www.tesla.com/models/design?financeModalTab=gas_savings#overview"
        }
    },
    {
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Cybertruck-Desktop.jpg",
        mobileImage: 'https://digitalassets.tesla.com/discovery-tesla-com/image/upload/f_auto,q_auto/Homepage-Cybertruck-Mobile.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/cybertruck/design"
            },
            {
                text: "Learn More",
                link: "https://www.tesla.com/cybertruck"
            }
        ]
    },
    {
        title: "Solar Panels",
        subTitle: "Schedule a Virtual Consultation",
        subTitleLink: "https://www.tesla.com/event/schedule-virtual-energy-consultations",
        color: "white",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-SolarPanels-01-Desktop",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-SolarPanels-01-Mobile.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/energy/design"
            },
            {
                text: "Learn More",
                link: "https://www.tesla.com/solarpanels"
            }
        ]
    },
    {
        title: "Solar Roof",
        subTitle: "Produce Clean Energy From Your Roof",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/h_1800,w_2880,c_fit,f_auto,q_auto:best/Homepage-SolarRoof-Desktop-Global",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/h_2100,q_auto:best/Homepage-SolarRoof-Mobile',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/solarroof/design"
            },
            {
                text: "Learn More",
                link: "https://www.tesla.com/solarroof"
            }
        ]
    },
    {
        title: "Powerwall",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Powerwall-01-Desktop.jpg",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Powerwall-01-Mobile.jpg',
        buttons: [
            {
                text: "Order Now",
                link: "https://www.tesla.com/powerwall/design"
            },
            {
                text: "Learn More",
                link: "https://www.tesla.com/powerwall"
            }
        ]
    },
    {
        title: "Accessories",
        image: "https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Accessories-Desktop-NA-APAC.jpg",
        mobileImage: 'https://digitalassets.tesla.com/tesla-contents/image/upload/f_auto,q_auto/Homepage-Accessories-Mobile-NA-APAC.jpg',
        buttons: [
            {
                text: "Shop Now",
                link: "https://shop.tesla.com/"
            }
        ]
    }
];